import { createSlice } from "@reduxjs/toolkit";
import {
  organisationalTeacherListAction,
  schoolAdminDeleteAction,
  schoolAdminDetailAction,
  schoolAdminResetPassAction,
  schoolAdminStudentIdListAction,
  schoolAdminSuspendAction,
  switchToAdminAction,
  teacheResetPassAction,
  teacherClassListAction,
  teacherCollectionListAction,
  teacherCsvListAction,
  teacherDeleteAction,
  teacherDetailAction,
  teacherListAction,
  teacherStudentIdListAction,
  teacherSuspendAction,
  weelklyLoginTeacherAction,
} from "../Action/teacherAction";

const initialState = {
  loading: false,
  teachers: {},
  organisationalTeachers: {},
  organisationalTeachersStatus: "idle",
  teacherDetail: {},
  schoolAdminDetail: {},
  teacheResetPassStatus: "idle",
  schoolAdminResetPassStatus: "idle",
  teacherCollectionListStatus: "idle",
  teacherClassListStatus: "idle",
  schoolAdminSuspendStatus: "idle",
  teacherSuspendStatus: "idle",
  teacherDeleteStatus: "idle",
  schoolAdminDeleteStatus: "idle",
  weelklyLoginTeacherStatus: "idle",
  switchToAdminStatus: "idle",
  teacherCsvListStatus: "idle",
  teacherStudentIdList: [],
  schoolAdminStudentIdList: [],
};

const teacherSlice = createSlice({
  loading: false,
  name: "teacher",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(teacherListAction.pending, (state, action) => {
        state.loading = true;
        state.teachers = action?.payload?.data;
      })
      .addCase(teacherListAction.fulfilled, (state, action) => {
        state.loading = false;
        state.teachers = action?.payload?.data;
      })
      .addCase(teacherListAction.rejected, (state, action) => {
        state.loading = false;
        state.teachers = action?.payload?.data;
      })
      .addCase(organisationalTeacherListAction.pending, (state) => {
        state.organisationalTeachersStatus = "pending";
      })
      .addCase(organisationalTeacherListAction.fulfilled, (state, action) => {
        state.organisationalTeachers = action?.payload?.data;
        state.organisationalTeachersStatus = "succeeded";
      })
      .addCase(organisationalTeacherListAction.rejected, (state) => {
        state.organisationalTeachersStatus = "failed";
      })
      .addCase(teacheResetPassAction.fulfilled, (state, action) => {
        state.teacheResetPassStatus = "succeeded";
      })
      .addCase(schoolAdminResetPassAction.fulfilled, (state, action) => {
        state.schoolAdminResetPassStatus = "succeeded";
      })

      .addCase(teacherDetailAction.fulfilled, (state, action) => {
        state.teacherDetail = action?.payload?.data;
      })

      .addCase(schoolAdminDetailAction.fulfilled, (state, action) => {
        state.schoolAdminDetail = action?.payload?.data;
      })

      .addCase(teacherCollectionListAction.fulfilled, (state, action) => {
        state.teacherCollectionListStatus = "succeeded";
      })
      .addCase(teacherClassListAction.fulfilled, (state, action) => {
        state.teacherClassListStatus = "succeeded";
      })

      .addCase(teacherSuspendAction.fulfilled, (state, action) => {
        state.teacherSuspendStatus = "succeeded";
      })
      .addCase(schoolAdminSuspendAction.fulfilled, (state, action) => {
        state.schoolAdminSuspendStatus = "succeeded";
      })

      .addCase(switchToAdminAction.fulfilled, (state, action) => {
        state.switchToAdminStatus = "succeeded";
      })

      .addCase(teacherDeleteAction.fulfilled, (state, action) => {
        state.teacherDeleteStatus = "succeeded";
      })

      .addCase(schoolAdminDeleteAction.fulfilled, (state, action) => {
        state.schoolAdminDeleteStatus = "succeeded";
      })

      .addCase(weelklyLoginTeacherAction.fulfilled, (state, action) => {
        state.weelklyLoginTeacherStatus = "succeeded";
      })

      .addCase(teacherCsvListAction.fulfilled, (state, action) => {
        state.teacherCsvListStatus = "succeeded";
      })

      .addCase(teacherStudentIdListAction.fulfilled, (state, action) => {
        state.teacherStudentIdList = action?.payload?.data;
      })

      .addCase(schoolAdminStudentIdListAction.fulfilled, (state, action) => {
        state.schoolAdminStudentIdList = action?.payload?.data;
      });
  },
});

export default teacherSlice.reducer;
